import addError from '../../../utils/error.jsx';
import { bulk } from './update';

export function request( sportId, eventTemplateId, marketTemplateId, data ) {
    return {
        type: 'MARKET_TEMPLATES_MOVE_SELECTION_REQUEST',
        sportId,
        eventTemplateId,
        marketTemplateId,
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'MARKET_TEMPLATES_MOVE_SELECTION_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(bulk(data));

        dispatch({
            type: 'MARKET_TEMPLATES_MOVE_SELECTION_FINISH',
            data
        });
    };
}
